// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />



export default class TestDrag {
    private id = 0;
    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }


    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        const image = new vf.gui.Image();
        image.src = './assets/dino.png';
        image.anchorX = 0.5;
        image.anchorY = 0.5;
        image.dragOption.draggable = true;
        image.dragOption.dragBoundary = true;
        image.dragOption.dragContainer = uiStage; //拖动时，移动对象到舞台，防止遮挡
        image.dragOption.dragBounces = true;//回弹
        image.y = 440;
        image.x = 400;
        uiStage.addChild(image);

        // uiStage.id = 'stage';
        const c1 = this.getNewContainer("自由拖动");
        c1.container.name = "c1";
        c1.container.x = 15;
        c1.container.y = 15;
        uiStage.addChild(c1.container);
        c1.container.dragOption.draggable = true;
        c1.container.dragOption.dragContainer = uiStage; //拖动时，移动对象到舞台，防止遮挡

        const c2 = this.getNewContainer("限定X轴移动");
        c2.container.x = 150;
        c2.container.y = 15;
        uiStage.addChild(c2.container);
        c2.container.dragOption.draggable = true;
        c2.container.dragOption.dragRestrictAxis = "x";

        const c3 = this.getNewContainer("限定Y轴移动");
        c3.container.x = 15;
        c3.container.y = 130;
        uiStage.addChild(c3.container);
        c3.container.dragOption.draggable = true;
        c3.container.dragOption.dragRestrictAxis = "y";

        const c4 = this.getNewContainer("限定边界");
        c4.container.x = 150;
        c4.container.y = 130;
        uiStage.addChild(c4.container);
        c4.container.dragOption.draggable = true;
        c4.container.dragOption.dragBoundary = true;//限定边界

        const c5 = this.getNewContainer("拖动回弹");
        c5.container.x = 15;
        c5.container.y = 250;
        uiStage.addChild(c5.container);
        c5.container.dragOption.draggable = true;
        c5.container.dragOption.dragBounces = true;//回弹

        const c7 = this.getNewContainer("接收容器", undefined, false);
        c7.container.x = 150;
        c7.container.y = 360;
        c7.container.name = "c7";
        c7.container.id = JSON.stringify(this.id++);
        c7.container.style.display = "grid";
        c7.container.style.gridTemplateColumns = ["repeat", 3, 30];
        c7.container.style.gridTemplateRows = ["repeat", 3, 30];
        c7.container.style.gridColumnGap = 10;
        c7.container.style.gridRowGap = 10;
        c7.container.width = 100;
        c7.container.height = 100;
        uiStage.addChild(c7.container);
        c7.container.dragOption.droppable = true;//开启掉落接收
        c7.container.dragOption.dropGroup = "group1";
        c7.container.on(vf.gui.Interaction.ComponentEvent.DROP_TARGET, (container: vf.gui.Container, source: vf.gui.Rect) => {
            console.log(container.name, source.name);
        });


        const c6 = this.getNewContainer("拖动到\n接收容器", undefined, false);
        c6.container.name = "c6";
        c6.container.x = 250;
        c6.container.y = 200;
        c6.container.scaleX = 2;
        c6.container.scaleY = 2;
        uiStage.addChild(c6.container);
        // ----------   绘制矩形设置可拖动 ---------- //
        let rect: vf.gui.Rect;
        for (let i = 0; i < 5; i++) {
            rect = new vf.gui.Rect();
            rect.name = "rect" + i.toString();
            rect.width = 30;
            rect.height = 30;
            rect.color = 0xffcc66;
            rect.lineColor = 0xffffff;
            rect.id = JSON.stringify(this.id++);
            rect.x = 0;
            rect.y = 0;
            rect.dragOption.dragBounces = true;
            rect.dragOption.draggable = true;//开启拖拽
            rect.dragOption.dragGroup = "group1"; //设置分组，同时需要设置接收掉落方的dropGroup。
            rect.on(vf.gui.Interaction.ComponentEvent.DRAG_START, (rect1: vf.gui.Rect) => {
                console.log("DRAG_START");
                //rect1.scaleX = rect1.scaleY = 1.5;
            }, this);
            rect.on(vf.gui.Interaction.ComponentEvent.DRAG_END, (rect1: vf.gui.Rect) => {
                console.log("DRAG_END");
                //rect1.scaleX = rect1.scaleY = 1;
            }, this);
            rect.on(vf.gui.Interaction.ComponentEvent.DRAG_TARGET, (rect1: vf.gui.Rect) => {
                console.log("DRAG_TARGET");
                //rect1.scaleX = rect1.scaleY = 1;
                rect1.dragOption.draggable = false;
            }, this);
            c6.container.addChild(rect);
        }

        const c8 = this.getNewContainer("自由拖动同步");
        c8.container.name = "c8";
        c8.container.x = 265;
        c8.container.y = 15;
        uiStage.addChild(c8.container);
        c8.container.dragOption.draggable = true;
        c8.container.dragOption.dragContainer = uiStage; //拖动时，移动对象到舞台，防止遮挡
        // c8.container.dragOption.dragBounces = true;
        c8.container.dragOption.dragGroup = "group1"; //设置分组，同时需要设置接收掉落方的dropGroup。
        c1.container.dragOption.dragGroup = "group1";
        c1.container.on(vf.gui.Interaction.ComponentEvent.DRAG_START, () => {
            //c8.container.dragOption.actionData = c1.container.dragOption.actionData;
            console.log('DRAG_START');
        }, this);
        c1.container.on(vf.gui.Interaction.ComponentEvent.DRAG_MOVE, () => {
            //c8.container.dragOption.actionData = c1.container.dragOption.actionData;
            console.log('DRAG_MOVE');
        }, this);
        c1.container.on(vf.gui.Interaction.ComponentEvent.DRAG_END, () => {
            //c8.container.dragOption.actionData = c1.container.dragOption.actionData;
            console.log('DRAG_END');
        }, this);
        c1.container.on(vf.gui.Interaction.ComponentEvent.DRAG_TARGET, () => {
            console.log('DRAG_TARGET');
            //c8.container.dragOption.actionData = c1.container.dragOption.actionData;
        }, this);
        c8.container.on(vf.gui.Interaction.ComponentEvent.DRAG_TARGET, () => {
            console.log('vf.gui.Interaction.ComponentEvent.DRAG_TARGET2');
        }, this);
        c8.container.on(vf.gui.Interaction.ComponentEvent.DRAG_START, () => {
            console.log('vf.gui.Interaction.ComponentEvent.DRAG_START');
        }, this);
        c8.container.on(vf.gui.Interaction.ComponentEvent.DRAG_MOVE, () => {
            console.log('vf.gui.Interaction.ComponentEvent.DRAG_MOVE');
        }, this);

        const c9c = this.getNewContainer("容器内拖动");
        c9c.container.name = "c9c";
        c9c.container.x = 15;
        c9c.container.y = 400;
        uiStage.addChild(c9c.container);
        const c9 = this.getNewContainer("拖");
        c9.container.name = "c9";
        c9.container.width = 20;
        c9.container.height = 20;
        c9.container.style.backgroundColor = 0xffcccc;
        c9.container.x = 10;
        c9.container.y = 10;
        c9.container.dragOption.dragContainer = c9c.container;
        c9c.container.addChild(c9.container);
        c9.container.dragOption.draggable = true;
        c9.container.dragOption.dragBoundary = true;//限定边界
        // c9.container.dragOption.dragBounces = true;//回弹
        c9.container.pivotX = c9.container.pivotY = 10;

        setTimeout(() => {
            console.log('xxxxdraggable1');
            c8.container.dragOption.draggable = false;
        }, 3000);
        setTimeout(() => {
            console.log('xxxxdraggable2');
            c8.container.dragOption.draggable = true;
        }, 6000);


        this.getButton('设置/取消dragContainer = uiStage', () => {
            if (c1.container.dragOption.dragContainer != undefined) {
                c1.container.dragOption.dragContainer = undefined;


            } else {
                c1.container.dragOption.dragContainer = uiStage;
            }

        }, uiStage, 500, 0);



        this.getButton('设置/取消c2.rect.dragOption.dragRestrictAxis = "x"', () => {
            if (c2.container.dragOption.dragRestrictAxis != undefined) {
                c2.container.dragOption.dragRestrictAxis = undefined;


            } else {
                c2.container.dragOption.dragRestrictAxis = "x";
            }

        }, uiStage, 500, 0);



        this.getButton('设置/取消边界', () => {
            if (c4.container.dragOption.draggable != false && c4.container.dragOption.dragBoundary != false) {
                c4.container.dragOption.draggable = false;
                c4.container.dragOption.dragBoundary = false;


            } else {
                c4.container.dragOption.draggable = true;
                c4.container.dragOption.dragBoundary = true;
            }

        }, uiStage, 500, 0);



        this.getButton('设置/取消Y轴', () => {
            if (c3.container.dragOption.dragRestrictAxis != undefined) {
                c3.container.dragOption.dragRestrictAxis = undefined;


            } else {
                c3.container.dragOption.dragRestrictAxis = "y";
            }

        }, uiStage, 500, 0);




        this.getButton('设置/取消拖动回弹', () => {
            if (c5.container.dragOption.draggable != false && c5.container.dragOption.dragBounces != false) {
                c5.container.dragOption.draggable = false;
                c5.container.dragOption.dragBounces = false;


            } else {
                c5.container.dragOption.draggable = true;
                c5.container.dragOption.dragBounces = true;
            }

        }, uiStage, 500, 0);



        this.getButton('设置/取消接受容器', () => {
            if (c7.container.dragOption.droppable != false) {
                c7.container.dragOption.dropGroup = "group1";


            } else {
                c7.container.dragOption.droppable = true;
                c7.container.dragOption.dropGroup = "group1";
            }

        }, uiStage, 500, 0);


        this.getButton('设置/取消同步', () => {
            if (c1.container.dragOption.dragGroup != "group6") {
                c1.container.dragOption.dragGroup = "group6";


            } else {
                c1.container.dragOption.dragGroup = "group1";
            }

        }, uiStage, 500, 0);
    }




    private getNewContainer(str: string, color = 0xffffff, rectVisible = true) {
        /** 单背景色 */
        const childContainer = new vf.gui.Container();
        new vf.gui.Interaction.ClickEvent(childContainer, true);
        childContainer.width = 100;
        childContainer.height = 100;
        childContainer.id = JSON.stringify(this.id++);
        childContainer.style.backgroundColor = color;

        const label = new vf.gui.Label();
        label.style.justifyContent = "center";
        label.style.alignContent = "center";
        label.style.color = 0x000000;
        label.style.fontSize = 24;
        label.style.wordWrap = true;
        label.style.wordWrapWidth = 100;
        label.text = str;
        childContainer.addChild(label);

        return { container: childContainer };
    }


    private posY = 10;
    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, fun);
        target.addChild(button);
        this.posY = this.posY + 25 + y;

        return button;
    }

}
